//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "Village",
};
